import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { ProjectInterface } from "../../../interfaces/ProjectInterface";
import { ProjectsListColumn } from "../../Projects/hooks/usePartnerProjectListColumns";

const columnHelper = createColumnHelper<ProjectInterface>();

interface UseEntityListColumnsInterface {
  columns: Array<ColumnDef<ProjectInterface, any>>;
}
const useEntityListColumns = (): UseEntityListColumnsInterface => {
  const { t } = useTranslation();

  const columns: Array<ColumnDef<ProjectsListColumn, any>> = [
    columnHelper.accessor("name", {
      header: `${t("PROJECT.name")}`,
      cell: (info) => info.getValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("description", {
      header: `${t("PROJECT.description")}`,
      cell: (info) => info.getValue(),
      footer: (info) => info.column.id,
    }),
  ];

  return { columns };
};

export default useEntityListColumns;
